export const isReferenceReadable = (
  isAccountTrial: boolean,
  isTrial: boolean
) => {
  return !isAccountTrial || isTrial;
};